import React from "react";
import FoodList from "../../component/Food/FoodList";
import FormMenuItem from "../../pages/FormMenuItem";
import { useSelector, useDispatch } from 'react-redux';
import "./FoodsPage.css"
import BackButton from "../../component/BackButton/BackButton.js";
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import { openGlobalPopup } from "../../redux/action.js";
import { ButtonLoader } from "../../component/common/Loader";

function FoodsPage() {
  const dispatch = useDispatch();
  const edit = useSelector((state) => state?.admin?.edit)
  const menuItemSaving = useSelector((state) => Boolean(state?.admin?.menuItemSaving));
  //const { category, allCategories } = location.state || {};
  // console.log("FoodPage category:", location.state)
  //console.log("FoodPage allCategories:", allCategories)
  console.log("edit Food Item:", edit)

  const closeFoodItemForm = () => {
    dispatch({ type: "EDIT_MENU_ITEM", payload: {} });
  };

  return (
    <div className="container">
      <div className="item-header">
        {/* <span onClick={() => navigate(-1)} class="back-btn item-back-btn">← Back</span> */}
        <BackButton to="/menu-categories" label="Back to Categories" variant="subtle" classAttribute="item-back-btn" />
        <h1 className="item-title">Manage Foods</h1>
      </div>
      {/* <h1> Manage Foods</h1> */}

      <button className="add-button ui-page-add-button"
        onClick={() => {
          dispatch({ type: "EDIT_MENU_ITEM", payload: {} });
          dispatch(openGlobalPopup("food-item-form"));
        }} >
        Add Food Item</button>

      <GlobalPopup
        popupKey="food-item-form"
        title={edit?.menuId ? "Edit Food Item" : "Add Food Item"}
        disableClose={menuItemSaving}
        onClose={closeFoodItemForm}
        footer={(closePopup) => (
          <>
            <button
              type="button"
              className="popup-action-btn secondary"
              disabled={menuItemSaving}
              onClick={closePopup}
            >
              Cancel
            </button>
            <button
              type="submit"
              form="food-item-form-fields"
              className="popup-action-btn"
              disabled={menuItemSaving}
              aria-busy={menuItemSaving}
            >
              {menuItemSaving ? <ButtonLoader label="Saving..." /> : edit?.menuId ? "Save Food Item" : "Add Food Item"}
            </button>
          </>
        )}
      >
        <FormMenuItem popupMode formId="food-item-form-fields" />
      </GlobalPopup>

      <section className="list-section">
        <FoodList />
      </section>
    </div>
  );
}

export default FoodsPage;
